import { Alert, TextField, Typography } from "@mui/material";
import { defaultVariables } from "lib/utilities/templates";
import { useEffect } from "react";
import TiptapEditor from "./JobForm/Tiptap";

const CloseJobFormTemplate = ({
  templates,
  handleTemplateChange,
  setTemplatesValid,
  requiredVariables,
  requiredVariableDesc,
  missingVariables,
  setMissingVariables,
  setStrExists,
  strExists
}) => {
  const checkTemplateVariables = (templateId, content) => {
    const required = requiredVariables[templateId] || [];
    const missing = required?.filter((variable) => !content?.includes(`{${variable}}`));
    setMissingVariables((prev) => ({
      ...prev,
      [templateId]: missing,
    }));

    const defaultStr = defaultVariables[templateId] || [];
    const exists = defaultStr?.filter((str) => content?.includes(str));
    setStrExists((prev) => ({
      ...prev,
      [templateId]: exists,
    }));

    setTemplatesValid(
      !Object.values(missingVariables).some((v) => (v || []).length > 0) &&
      !Object.values(strExists).some((s) => (s || []).length > 0)
    );
  };

  useEffect(() => {
    Object.keys(templates).forEach((templateId) => {
      checkTemplateVariables(templateId, templates[templateId]);
    });
  }, [templates]);

  const handleTemplateChangeAndValidate = (event) => {
    const { id, value } = event.target;
    handleTemplateChange(event);
    checkTemplateVariables(id, value);
  };

  return (
    <div className="p-5 pt-0">
      <Typography variant="h4">
        Mail Template Form
      </Typography>
      <Typography variant="caption">
        There are a few variables which should be included in the template to provide details about
        the interview process to the candidates. You may include these variables in the templates by
        enclosing them within curly braces preceded with a dollar sign. <br /> For example, to
        include the name of the candidate, you can use the variable <code>{`\${name}`}</code>.
      </Typography>
      <Typography variant="h5" gutterBottom mt={2}>
        Close Job Form Template
      </Typography>
      
      {requiredVariableDesc.closeJobFormTemplate.map((v) => (
        <Typography variant="caption">
          <code>
            ${"{" + v.name + "}"}: {v.desc}
          </code>
          <br />
        </Typography>
      ))}

      <TextField
        id="closeJobFormSubject"
        label="Close Job Form Subject"
        fullWidth
        variant="outlined"
        value={templates.closeJobFormSubject}
        onChange={handleTemplateChange}
        sx={{ mt: 2 }}
      />
      <TiptapEditor
        id="closeJobFormTemplate"
        value={templates.closeJobFormTemplate}
        onChange={handleTemplateChangeAndValidate}
        placeholder="Provide the interview invite mail template here..."
      />
      {missingVariables?.closeJobFormTemplate?.length > 0 && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          Missing variable{missingVariables.closeJobFormTemplate.length > 1 && "s"}:{" "}
          {missingVariables.closeJobFormTemplate.join(", ")}
        </Alert>
      )}
      {strExists?.closeJobFormTemplate?.length > 0 && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          Missing Essential Information{strExists.closeJobFormTemplate.length > 1 && "s"}:{" "}
          {strExists.closeJobFormTemplate.join(", ")}
        </Alert>
      )}
    </div>
  )
}

export default CloseJobFormTemplate